import { SortFilter, SORT_FILTER_DISCRIMINATOR } from "./pagination";

const isSortFilter = (object?: any): object is SortFilter => object?.discriminator === SORT_FILTER_DISCRIMINATOR;

const isSortFilterArray = (object?: any): object is SortFilter[] => {
  return object && Array.isArray(object) && object.every(isSortFilter);
};

export { isSortFilter, isSortFilterArray };
